import {
  videosList,
  videosFilter,
  livesList,
  myEventsList,
  myContent,
  profile,
  planDetails,
  billingSettings,
  purchaseHistory,
  myList,
  members,
  userLimits,
  planning
} from 'config/routes';
import config from '../../config';
// export const mainMenuMore = [

//     {
//         path: config.VU_HOST,
//         titleKey: 'header.menu.verification'
//     },
//     {
//         path: 'https://agency.ruptly.tv/',
//         titleKey: 'header.menu.agency'
//     }
// ];

export const aboutMenu = [
  {
    path: '/about-ruptly',
    titleKey: 'page.about.submenu.about',
  },
  // {
  //   path: '/about-ruptly/team',
  //   titleKey: 'page.about.submenu.team',
  // },
];

export const mainMenu = [
  {
    path: videosList.getPath(),
    titleKey: 'header.menu.vod',
    children: [
      {
        titleKey: 'header.menu.vod.latest',
        path: videosList.getPath(),
        exact: true,
      },
      {
        title: 'COVID-19',
        path: videosFilter.getPath(),
        tag: 'covid-19',
        exact: true,
      },
      {
        titleKey: 'header.menu.vod.sports',
        path: videosFilter.getPath(),
        category: 'sports',
        exact: true,
      },
      // {
      //     titleKey: 'header.menu.vod.close_up',
      //     path: videosFilter.getPath(),
      //     tag: 'closeup',
      //     exact: true,
      // },

      {
        titleKey: 'header.menu.vod.lightnews',
        path: videosFilter.getPath(),
        category: 'light-news',
        exact: true,
      },
      // {
      //     titleKey: 'header.menu.vod.360',
      //     path: videosFilter.getPath('', '360'),
      //     search: '?q[format_eq]=1',
      //     exact: true,
      // },
      {
        titleKey: 'header.menu.vod.partner_content',
        path: videosFilter.getPath(),
        tag: 'partner-content',
        exact: true,
      },
    ],
  },
  {
    path: livesList.getPath(),
    titleKey: 'header.menu.live',
    exact: true,
    children: [
      {
        titleKey: 'header.menu.live.all_events',
        path: livesList.getPath(),
        exact: true,
        private: true,
      },
      {
        titleKey: 'header.menu.live.my_events',
        path: myEventsList.getPath(),
        exact: true,
        private: true,
      },
    ],
  },
  {
    path: '/broadcast-services',
    titleKey: 'header.menu.broadcast',
  },
  {
    path: config.VU_HOST,
    titleKey: 'header.menu.verification',
    exact: true,
    locale: true,
    children: [
      {
        path: config.VU_HOST,
        titleKey: 'header.menu.verification.blog',
        exact: true,
        locale: true,
      },
      // {
      //     path: 'https://vu.ruptly.tv/tag/freelance-guidelines/',
      //     titleKey: 'header.menu.verification.freelance',
      //     exact: true
      // },
      // {
      //     path: 'https://vu.ruptly.tv/tag/public-outreach/',
      //     titleKey: 'header.menu.verification.public_outreach',
      //     exact: true
      // },
      {
        path: '/about-us/',
        titleKey: 'header.menu.verification.about_vu',
        exact: true,
        locale: true,
        origin: config.VU_HOST,
      },
    ],
  },
  {
    path: '/plans',
    titleKey: 'header.menu.pricing',
  },
  {
    path: config.MEDIA_CENTRE,
    titleKey: 'header.menu.mediacentre',
    exact: true,
  },
  {
    path: '/about-ruptly',
    titleKey: 'footer.link.about',
    exact: true,
    children: [
      {
        path: '/about-ruptly',
        titleKey: 'header.menu.about',
        exact: true,
      },
      // {
      //   path: '/about-ruptly/team',
      //   titleKey: 'header.menu.about.team',
      //   exact: true,
      // },
      {
        path: '/career',
        titleKey: 'header.menu.careers',
        exact: true,
      },
    ],
  },

  // {
  //     path: 'https://agency.ruptly.tv/',
  //     titleKey: 'header.menu.agency',
  //     xact: true,
  //     children: [
  //         {
  //             path: 'https://agency.ruptly.tv/',
  //             titleKey: 'header.menu.agency.about',
  //             exact: true
  //         },
  //         {
  //             path: 'https://agency.ruptly.tv/tag/hr/',
  //             titleKey: 'header.menu.agency.hr',
  //             exact: true
  //         },
  //         {
  //             path: 'https://agency.ruptly.tv/impressum/',
  //             titleKey: 'header.menu.agency.impressum',
  //             exact: true
  //         }
  //     ]
  // }
];

export const isClient = (state) => {
  return state.user.currentUser.payload.user_group === 'client';
};

export const hasNotAgreementsOrMembers = (state) => {
  return (
    state.user.userLimitsAgreements.payload.length <= 0 ||
    state.user.currentUser.payload.members_count <= 0
  );
};

export const noHasMembers = (state) => {
  const user = state.user.currentUser.payload;

  return user.members_count <= 0 && user.only_one_off;
};

export const userMenu = [
  {
    titleKey: 'page.profile.menu.my_content',
    path: myContent.getPath(),
    exact: true,
  },
  {
    titleKey: 'page.profile.menu.profile',
    path: profile.getPath(),
  },
  {
    titleKey: 'page.profile.menu.plan_details',
    path: planDetails.getPath(),
  },
  {
    titleKey: 'page.profile.menu.billing_settings',
    path: billingSettings.getPath(),
    disabled: isClient,
  },
  {
    titleKey: 'page.profile.menu.purchase_history',
    path: purchaseHistory.getPath(),
    disabled: isClient,
  },
  {
    titleKey: 'page.profile.menu.my_lists',
    path: myList.getPath(),
  },
  {
    titleKey: 'page.profile.menu.members',
    path: members.getPath(),
    disabled: (state) => {
      return isClient(state) || noHasMembers(state);
    },
  },
  {
    titleKey: 'page.profile.menu.user_limits',
    path: userLimits.getPath(),
    disabled: (state) => {
      return (
        isClient(state) ||
        noHasMembers(state) ||
        hasNotAgreementsOrMembers(state)
      );
    },
  },
  {
    titleKey: 'page.profile.menu.planning',
    path: planning.getPath(),
    disabled: (state) => !!(state.user.planningAccess.error),
  },
];
